import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const SETTING_LABEL = { default_visibility: "Posts visible to", message_privacy: "Who can message", show_suburb: "Suburb shown on profile", friend_list_visible: "Friend list visible" };

export const AgePolicy = () => {
  const [d, setD] = useState(null);
  const [min, setMin] = useState("");
  const load = () => api.get("/admin/privacy/age-policy").then((r) => { setD(r.data); setMin(String(r.data.min_age)); });
  useEffect(() => { load(); }, []);
  const save = async () => { try { await api.put("/admin/privacy/age-policy", { min_age: Number(min) }); toast.success("Minimum age updated"); load(); } catch (e) { toast.error(errMsg(e)); } };
  if (!d) return <Spinner />;
  return (
    <div className="space-y-4" data-testid="admin-age-policy">
      <div className="grid grid-cols-3 gap-3">{[["minors", "Under-18 accounts"], ["no_date_of_birth", "Accounts without a date of birth"], ["blocked_under_min", "Sign-ups refused (under minimum)"]].map(([k, l]) => (
        <div key={k} className="surface p-4" data-testid={`age-count-${k}`}><p className="font-serif text-3xl">{d.counts[k]}</p><p className="text-xs text-slate-500">{l}</p></div>))}</div>
      <section className="surface space-y-3 p-5"><h3 className="text-xl">Minimum age</h3>
        <p className="text-xs text-slate-500">Applies everywhere. People below it are refused at sign-up and the account they just created is deleted. Check: {d.assurance}.</p>
        <div className="flex gap-2"><Input type="number" min={13} max={21} className="w-28" value={min} onChange={(e) => setMin(e.target.value)} data-testid="age-min-input" />
          <Button variant="outline" className="rounded-full" onClick={save} disabled={Number(min) === d.min_age} data-testid="age-min-save">Save</Button></div></section>
      <section className="surface space-y-2 p-5"><h3 className="text-xl">Under-18 protections</h3>
        <ul className="space-y-1 text-sm text-slate-700" data-testid="minor-settings">{Object.entries(d.minor_settings).map(([k, v]) => <li key={k}>• {SETTING_LABEL[k] || k}: <b>{v === false ? "off" : String(v)}</b> by default</li>)}
          <li>• Personalised commercial content, marketing and precise location: <b>always off</b></li>
          <li>• Personalised recommendations and approximate location: <b>off until the member turns them on</b></li></ul></section>
    </div>
  );
};
